(ns practitest.frontend.forms3.link-to-external-modal.events
  (:require [ajax.core :as ajax]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.notifications :as notifications]
            [re-frame.core :as re-frame]))

(defn toggle-link-to-external-modal
  [db [_]]
  (let [new-show? (not (get-in db [:link-to-external-modal :show-link-to-external-modal?]))]
    (re-frame/dispatch [::refresh-modal])
    (assoc-in db [:link-to-external-modal :show-link-to-external-modal?] new-show?)))

(re-frame/reg-event-fx
  ::refresh-modal
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:link-to-external-modal :local-state] {})
     :dispatch-n [[::clear-fields]
                  [::clear-notifications]]}))

(re-frame/reg-event-fx
  ::toggle-link-to-external-modal
  (fn [{:keys [db]} data]
    {:db (toggle-link-to-external-modal db data)}))

(re-frame/reg-event-db
  ::set-field-state
  (fn [db [_ field-id new-state]]
    (let [current-state (get-in db [:link-to-external-modal :fields field-id])]
      (update-in db [:link-to-external-modal :fields field-id] merge new-state))))

(re-frame/reg-event-db
  ::clear-notifications
  (fn [db _]
    (assoc-in db [:link-to-external-modal :link-to-external-modal-notifications] [])))

(re-frame/reg-event-db
  ::clear-fields
  (fn [db _]
    (assoc-in db [:link-to-external-modal :fields] nil)))

(defn link-ticket-finished [db [_ entity-type grid-state response]]
  (-> db
      (assoc-in [:link-to-external-modal :link-to-external-modal-notifications] response)
      (update :progress disj ::link-ticket)))

(re-frame/reg-event-db
  ::link-ticket-finished
  link-ticket-finished)

(defn link-ticket [{db :db} [_ grid-state [uri params]]]
  (let [{:keys [entity-type]} params]
    {:db (update db :progress conj ::link-ticket)
     :http-xhrio
     {:method          :post
      :uri             uri
      :format          (ajax/json-request-format)
      :vec-strategy    :rails
      :params          params
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::link-ticket-finished entity-type grid-state]
      :on-failure      [:practitest.frontend.events/api-error
                        ::link-ticket
                        "Error while linking ticket"
                        (get-translation "entity.link_modal.error.link_ticket" "Error while linking ticket")]}}))

(re-frame/reg-event-fx
  ::link-ticket
  link-ticket)

(re-frame/reg-event-fx
  ::unlink-ticket-finished
  (fn [{db :db} [_ response]]
    { :db         (update db :progress disj ::unlink-ticket)
     :dispatch-n [(when (:success response)
                    [::notifications/success2 (:success response)])]}))

(defn unlink-ticket [{:keys [db]} [_ {:keys [uri params]}]]
  (let [_ params
        params (merge params {:new_link_modal_ui true})]
    {:db (update db :progress conj ::unlink-ticket)
     :http-xhrio
     {:method          :post
      :uri             uri
      :params          params
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::unlink-ticket-finished]
      :on-failure [:practitest.frontend.events/api-error
                   [::unlink-ticket]
                   {:message (get-translation "entity.link_modal.error.unlink_ticket" "Failed to unlink the ticket")}]}}))

(re-frame/reg-event-fx
  ::unlink-ticket
  unlink-ticket)
